import stripTrailingSlash from '@/core/utils/strip-trailing-slash';

const BOOKING_MANAGE_PATH_PATTERN = /^\/booking\/manage(\/|$)/i;

const isBookingManagePathname = (pathname: string): boolean => {
  const cleanPath = stripTrailingSlash(
    pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?\//, '/').replace(/\?.*$/, ''),
  );

  return BOOKING_MANAGE_PATH_PATTERN.test(cleanPath);
};

export default isBookingManagePathname;
